import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()

export class CampaignService {
	CAMPAIGN_URI: string = environment.apiUrl + '/campaign';

	constructor(private httpClient: HttpClient) {}

	public getAll = () => {
		return this.httpClient.get(this.CAMPAIGN_URI);
	}

	public getCampaign = (id) => {
		return this.httpClient.get(this.CAMPAIGN_URI + `/${id}`);
	}

	public getCampaignByClient = (id) => {
		return this.httpClient.get(this.CAMPAIGN_URI + `/byClient/${id}`);
	}
	
	public create = (body) => {
		return this.httpClient.post(this.CAMPAIGN_URI, body);
  }
  
  public update = (body, id) => {
		return this.httpClient.put(this.CAMPAIGN_URI + `/${id}`, body);
	}

	public delete = (id) => {
		return this.httpClient.delete(this.CAMPAIGN_URI + `/${id}`);
	}
}


// WEBPACK FOOTER //
// ./src/app/services/campaign.service.ts